<template>
  <v-container fill-height>
    <v-row justify="center" align="center">
        <v-col xs="12" lg="5">

            <v-card
              elevation="2"
              light
            >
              <v-row>
                <v-col cols="12" lg="6">
                  <v-container fill-height>
                    <v-row justify="center" align="center">
                        <v-col cols="6">
                          <v-layout justify="center">
                            <img class="img-fluid" :src="require('@/assets/logo-full.svg')"/>
                          </v-layout>
                        </v-col>
                    </v-row>
                  </v-container>
                </v-col>
                <v-col cols="12" lg="6">
                  <v-form
                    justify="center"
                    v-model="valid"
                    ref="form"
                  >
                    <v-card-text>
                      <h3>{{ $t('Fill in your password and confirm to activate your account') }}</h3>
                      <v-text-field
                        :label="$t('Password')"
                        required
                        type="password"
                        v-model="loginForm.password"
                        :rules="passwordRules"
                      ></v-text-field>
                      <v-text-field
                        :label="$t('Confirm Password')"
                        required
                        type="password"
                        v-model="loginForm.passwordRepeat"
                        :rules="passwordRules"
                      ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        block
                        color="primary"
                        @click="changePassword"
                      >
                        {{ $t('Activate Account') }}
                      </v-btn>
                    </v-card-actions>
                    <v-card-actions>
                      <router-link class="text-caption" :to="{ name: 'Home' }">{{ $t('Login') }}</router-link>
                    </v-card-actions>

                    <v-card-actions class="d-block">
                      <v-alert
                        dense
                        type="error"
                        v-if="error.length > 0"
                      >
                        {{error}}
                      </v-alert>
                    </v-card-actions>
                  </v-form>
                </v-col>
              </v-row>
            </v-card>
        </v-col>
    </v-row>
</v-container>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      valid: false,
      loginForm:{
        passwordRepeat: '',
        password: '',
      },
      passwordRules: [
        v => (v && v.length >= 8) || this.$t('Password must be at least 8 characters'),
        v => /\W|_/g.test(v) || this.$t('Password must have at least one special character'),
        v => /[A-Z]/.test(v) || this.$t('Password must have at least one capital'),
      ],
      error: "",
    }
  },
  methods: {
    changePassword(){
      console.log('send reset')
      console.log(this.loginForm)
      var scope = this
      if(scope.$refs.form.validate()){
        if(this.loginForm.password != this.loginForm.passwordRepeat){
            scope.error = scope.$t("Confirm Password not Match to Password")
            return false;
        }
        scope.loginForm.hash = this.$route.params.token;
        scope.success = ""
        axios.post(scope.$urlPrefix + "/Authentication/ActivateUser",scope.loginForm)
        .then(response => {
          console.log(response)
          scope.$store.dispatch('setSnack', {icon:"mdi-alert", color:'green', msg:"Account activated successfully!"})
          scope.$router.push({name: 'Home'});
        })
        .catch(function(e){
          scope.error = scope.$t(e.response.data)
        })
      }
    }
  },
}
</script>

<style lang="scss">
button.text-caption {
    padding: 0 !important;
}
</style>
